import { useMutation } from 'react-query';

import { resetPassword as mutationFn } from 'api/endPoints/resetPassword';

export const useMutationPasswordReset = () => {
    return useMutation<unknown, QueryError, any>((params) => mutationFn(params));
};
